// Project shortcuts (Firebase's "Project shortcuts"): pages pinned with the ☆ in a page head, kept
// per viewer in localStorage and shared by the rail and every page head.
import { useSyncExternalStore } from "react";

const KEY = "estra.console.shortcuts";
const subs = new Set<() => void>();
let state: Record<string, string[]> = load();

function load(): Record<string, string[]> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "{}") as Record<string, string[]>;
  } catch {
    return {};
  }
}
function save() {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    /* private window: memory only */
  }
  subs.forEach((s) => s());
}

const EMPTY: string[] = [];
export function useShortcuts(projectId: string | undefined): string[] {
  return useSyncExternalStore(
    (cb) => (subs.add(cb), () => void subs.delete(cb)),
    () => (projectId ? (state[projectId] ?? EMPTY) : EMPTY),
  );
}
/** `page` is "<product>" or "<product>/<tab>". */
export function toggleShortcut(projectId: string, page: string) {
  const cur = state[projectId] ?? [];
  state = { ...state, [projectId]: cur.includes(page) ? cur.filter((p) => p !== page) : [...cur, page] };
  save();
}
